import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Thunderbolt",
  "use": "icon-Thunderbolt-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-Thunderbolt\"><path fill=\"#FA8C16\" d=\"M14 5.272h-3.934l3.537-4.47a.143.143 0 0 0-.112-.232H6.643a.14.14 0 0 0-.123.072l-4.627 7.99a.142.142 0 0 0 .123.215H5.13l-1.596 6.386c-.034.14.134.237.237.137l10.327-9.853A.142.142 0 0 0 14 5.272m-8.39 6.664 1.077-4.303h-2.81l3.385-5.847h4.011l-3.72 4.702h3.768z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol